module.exports = __webpack_public_path__ + "static/LogoDevBranco-0dedb993f7a9bb61249df63509673679.png";